import React from 'react'
import freeDelivery from './layout/assets/freeDelivery.png'
import allDay from './layout/assets/allDay.png'
import trust from './layout/assets/trust.png'

function HomeIcons() {
    return (
        <div className="flex flex-wrap justify-center gap-8 bg-gray-100 mt-20">
            <div className="flex flex-col items-center text-center bg-gray-100 p-1 w-64 ">
                <img src={allDay} alt="24/7 купување и поддршка" className="sm:w-32  w-[100px]" />
                <p className="mt-2 text-sm sm:text-base">24/7 купување и поддршка</p>
            </div>
            <div className="flex flex-col items-center text-center bg-gray-100 p-1  w-64 ">
                <img src={freeDelivery} alt="Бесплатна достава" className="sm:w-32  w-[100px]" />
                <p className="mt-2 text-sm sm:text-base">Бесплатна достава за пратки над 3500 денари (Скопје над 1800 денари)</p>
            </div>
            <div className="flex flex-col items-center text-center bg-gray-100 p-1  w-64 ">
                <img src={trust} alt="Безбедно купување" className="sm:w-32 w-[100px]" />
                <p className="mt-2 text-sm sm:text-base">Купувајте безбедно, нашиот сајт е безбеден со SSL сертификати</p>
            </div>
        </div>
    )
}

export default HomeIcons
